import { MEDIA_QUERIES as MEDIA_QUERIES$1, fonts as fonts$1, tooltip as tooltip$1, pinkishTheme as pinkishTheme$1, reddishTheme as reddishTheme$1 } from '@lemonade-hq/nuis-atomic';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var MEDIA_QUERIES = MEDIA_QUERIES$1;
var fonts = fonts$1;
// tooltip
var tooltip = tooltip$1;
// themes
var pinkishTheme = pinkishTheme$1;
var reddishTheme = reddishTheme$1;
var _obj;
var themes = (_obj = {}, _define_property(_obj, pinkishTheme.name, pinkishTheme), _define_property(_obj, reddishTheme.name, reddishTheme), _obj);
var DEFAULT_THEME = pinkishTheme;

export { DEFAULT_THEME, MEDIA_QUERIES, fonts, pinkishTheme, reddishTheme, themes, tooltip };
